<template>
    <div class="light-variation-items">
        <v-list class="py-0">
            <v-list-item
                v-for="(lightVariation, index) in lightVariationsList"
                :key="index"
                selectable
                class="text-truncate"
                :class="{ active: lightVariation.active }"
                @click.prevent="selectVariation(lightVariation)"
            >
                <v-list-item-title class="text-none">
                    {{ lightVariation.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: "LightVariationItems",
        props: {
            lightVariationsList: {
                type: Array,
                required: true
            }
        },
        methods: {
            selectVariation(variation) {
                if (!variation.active)
                    this.$emit('select-variation', variation);
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/lightVariation/LightVariationItems.vue